import { gql } from "@apollo/client";

export const ADD_BADGE = gql`
  mutation addBadge(
    $name: String!
    $description: String
    $icon_url: String
    $criteria_type: String!
    $criteria_value: Int!
  ) {
    insert_badge(
      objects: [
        {
          name: $name
          description: $description
          icon_url: $icon_url
          criteria_type: $criteria_type
          criteria_value: $criteria_value
        }
      ]
    ) {
      affected_rows
      returning {
        badge_id
      }
    }
  }
`;

export const UPDATE_BADGE = gql`
  mutation updateBadge($id: uuid!, $badge: badge_set_input!) {
    update_badge(where: { badge_id: { _eq: $id } }, _set: $badge) {
      affected_rows
    }
  }
`;

export const DELETE_BADGE = gql`
  mutation deleteBadge($id: uuid!) {
    delete_badge(where: { badge_id: { _eq: $id } }) {
      affected_rows
    }
  }
`;

export const ADD_USER_BADGE = gql`
  mutation addUserBadge($user_id: uuid!, $badge_id: uuid!) {
    insert_user_badge(
      objects: [{ user_id: $user_id, badge_id: $badge_id }]
      on_conflict: {
        constraint: user_badge_user_id_badge_id_key
        update_columns: []
      }
    ) {
      affected_rows
      returning {
        user_badge_id
      }
    }
  }
`;
